import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ApplicationDestination } from '../selectors/application-destination';
import SectionMessage from '@atlaskit/section-message';

export interface Props {
  applicationDestination: ApplicationDestination | null;
  emailAddress: string;
  suggested?: boolean;
}

type MessageProps = {
  suggested: boolean;
} & Props;

const Message = ({ applicationDestination, emailAddress, suggested }: MessageProps) => {
  if (!applicationDestination) {
    return (
      <FormattedMessage
        id="login.unauthorized.email.body"
        defaultMessage="<strong>{email}</strong> doesn't have access to this content."
        values={{
          strong: chunks => <strong>{chunks}</strong>,
          email: emailAddress,
        }}
      />
    );
  }

  if (applicationDestination.destinationHostname) {
    if (suggested) {
      return (
        <FormattedMessage
          id="login.unauthorized.host.suggested.body"
          defaultMessage="<strong>{email}</strong> doesn't have access to <strong>{host}</strong>. Switch to the below account to continue."
          values={{
            strong: chunks => <strong>{chunks}</strong>,
            email: emailAddress,
            host: applicationDestination.destinationHostname,
          }}
        />
      );
    }

    return (
      <FormattedMessage
        id="login.unauthorized.host.body"
        defaultMessage="<strong>{email}</strong> doesn't have access to {application} on <strong>{host}</strong>."
        values={{
          strong: chunks => <strong>{chunks}</strong>,
          application: applicationDestination.applicationName,
          email: emailAddress,
          host: applicationDestination.destinationHostname,
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id="login.unauthorized.application.body"
      defaultMessage="<strong>{email}</strong> doesn't have access to this content on <strong>{application}</strong>."
      values={{
        strong: chunks => <strong>{chunks}</strong>,
        application: applicationDestination.applicationName,
        email: emailAddress,
      }}
    />
  );
};

const UnauthorizedComponent = ({ applicationDestination, emailAddress, suggested }: Props) => {
  return (
    <SectionMessage testId="unauthorized-user" appearance="warning">
      <Message
        applicationDestination={applicationDestination}
        emailAddress={emailAddress}
        suggested={!!suggested}
      />
    </SectionMessage>
  );
};

export default UnauthorizedComponent;
